
import React from "react";
import { Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";

const DAYS_OF_WEEK = ["Sun","Mon","Tues","Wed","Thurs","Fri","Sat"];

function weekOfYear(theDate){
    let onejan = new Date(theDate.getFullYear(), 0, 1);
    return Math.ceil( (((theDate.getTime() - onejan.getTime()) / 86400000) + onejan.getDay() + 1) / 7 );
}

function displayCurrency(number){
    return number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    });
}

function getNumberedColResults(data, colName, valueTotal){
    let colData = "";
    for(let i =1; i <= valueTotal; i++){
        let colKey = i + "_" + colName;
        if(i > 1){
            colData = colData + ' / ';
        }
        colData = colData + data[colKey];
    }
    return colData;
}

function getEmptyCounterMap(values){
    let mp = {};
    for(let i =1; i<=values; i++){
        mp[i] = 0;
    }
    return mp;
}

function printCounterMap(data, values){
    let valueStr = "";
    for(let i =1; i <= values; i++){
        if(i > 1){
            valueStr = valueStr + '/';
        }
        valueStr = valueStr + data[i];
    }
    return valueStr;
}

function IndicatorPerfSummaryList(props) {
    const summaryData = props.summaryData;
    let totalDays = 0;
    let totalIndicators = 0;
    let weekIndicators = 0;
    let monthIndicators = 0;

    let percentWinnersWeek = getEmptyCounterMap(5);
    let countWinnersWeek =  getEmptyCounterMap(5);
    let percentWinnersMonth =  getEmptyCounterMap(5);
    let countWinnersMonth =  getEmptyCounterMap(5);

    let percentWinnersTotal =  getEmptyCounterMap(5);
    let countWinnersTotal =  getEmptyCounterMap(5);

    const listItems =[];

    let week = 0;
    let month = 0;
    for(let index = 0; index< summaryData.length; index++){
        let summary = summaryData[index];
        let theDay = new Date(summary.testDate);
        let generatedOn = new Date(summary.generatedDate);

        let link = `/performance/chart`;


        if(summary.date != "none") {
            let currentItemWeek = weekOfYear(theDay);
            let currentItemMonth = theDay.getMonth();

            if(week !== currentItemWeek){
                listItems.push(<Row key={index +'_week_summary'}>
                    <Col>Week Indicators:{weekIndicators}</Col>
                    <Col>Percent Winners:{printCounterMap(percentWinnersWeek, 5)}</Col>
                    <Col>Point Winners:{printCounterMap(countWinnersWeek, 5)}</Col>
                </Row>);
                week = currentItemWeek;
                percentWinnersWeek = getEmptyCounterMap(5);
                countWinnersWeek =  getEmptyCounterMap(5);
                weekIndicators =0;
            }

            if(month !== currentItemMonth){
                listItems.push(<Row key={index +'_month_summary'}>
                    <Col>Month Indicators:{monthIndicators}</Col>
                    <Col>Percent Winners:{printCounterMap(percentWinnersMonth, 5)}</Col>
                    <Col>Point Winners:{printCounterMap(countWinnersMonth, 5)}</Col>
                </Row>);
                month = currentItemMonth;
                percentWinnersMonth = getEmptyCounterMap(5);
                countWinnersMonth =  getEmptyCounterMap(5);
                monthIndicators=0;
            }

            totalDays++;
            totalIndicators += summary.totalCount;
            weekIndicators += summary.totalCount;
            monthIndicators += summary.totalCount;

            for(let i =1; i <=5; i++){
                percentWinnersWeek[i] += summary[i + "_percent_winners"];
                percentWinnersMonth[i] += summary[i + "_percent_winners"];
                percentWinnersTotal[i] += summary[i + "_percent_winners"];

                countWinnersWeek[i] += summary[i + "_point_winners"];
                countWinnersMonth[i] += summary[i + "_point_winners"];

                countWinnersTotal[i] += summary[i + "_point_winners"];
            }

            let dateArg = theDay.toISOString().slice(0, 10).replaceAll('-', '');
            link = `/performance/chart?date=${dateArg}&config=${summary.config.name}`;
        }

        listItems.push(<Row key={index}>
            <Col>{DAYS_OF_WEEK[theDay.getDay()]}</Col>
            <Col>{theDay.toLocaleDateString("en-US")}</Col>
            <Col>{summary.totalCount}</Col>
            <Col>{summary.avgRisk}</Col>
            <Col>{summary.avgProfit}</Col>
            <Col>{getNumberedColResults(summary, 'percent_winners', 5)}</Col>
            <Col>{getNumberedColResults(summary, 'percent_win_percent', 5)}</Col>
            <Col>{getNumberedColResults(summary, 'point_winners', 5)}</Col>
            <Col>{getNumberedColResults(summary, 'point_win_percent', 5)}</Col>
            <Col>{generatedOn.toLocaleString("en-US")}</Col>
            <Col>{summary.ticksProcessed}</Col>
            <Col><Link to={`${link}`}>view</Link></Col>
        </Row>);
    }

    listItems.push(<Row key={'_total_summary'}>
        <Col>Total Indicators:{totalIndicators}</Col>
        <Col>Percent Winners:{printCounterMap(percentWinnersTotal, 5)}</Col>
        <Col>Point Winners:{printCounterMap(countWinnersTotal, 5)}</Col>
    </Row>);

    return (
        <div className="press-grid">
            <Container style={{'margin':'10px 0'}} >
                <Row>
                    <Col>Day</Col>
                    <Col>Date</Col>
                    <Col>Total Count</Col>
                    <Col>Avg Risk</Col>
                    <Col>Avg Profit</Col>
                    <Col>% Win Cnt 1/2/3/4</Col>
                    <Col>% Win % 1/2/3/4</Col>
                    <Col>Point Win Cnt 1/2/3/4</Col>
                    <Col>Point Win % 1/2/3/4</Col>
                    <Col>Generated On:</Col>
                    <Col>Ticks Processed:</Col>
                    <Col>View</Col>
                </Row>
                {listItems}
            </Container>
        </div>
    );
}
export {IndicatorPerfSummaryList}
